module.exports = __webpack_public_path__ + "img/getvip.26f74be2.png";